<template>
  <ModalBase show-modal auto-h narrow @close-modal="close" class="gk-modal-invoice-details">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
          {{ $gettext('EDIT') }}
        </template>
        <template v-slot:title>
          {{ $gettext('Invoice details') }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <div v-if="invoice" class="step-1--options-wrap">
        <div class="step-1--options gk-input-light">
          <div class="step-1--options__option">
            <div class="invoice-section--label">{{ $gettext('Invoice Number') }}</div>
            <b-form-input v-model="invoice.number" :placeholder="$gettext('invoice number')" />
          </div>
          <div class="step-1--options__option">
            <div class="invoice-section--label">{{ $gettext('Invoice Date') }}</div>
            <b-form-datepicker id="input-1" v-model="invoice.invoice_date" no-flip initial-date="2021-01-01" :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }" />
          </div>
          <div class="step-1--options__option">
            <div class="invoice-section--label">{{ $gettext('Project Reference') }}</div>
            <b-form-input v-model="invoice.reference" :placeholder="$gettext('project reference')" />
          </div>
          <!-- payment options -->
          <div v-if="!invoice.paid_up_front" class="step-1--options__option">
            <div class="invoice-section--label">{{ $gettext('Payment term') }}</div>
            <b-input-group>
              <template #append>
                <b-input-group-text>{{ $gettext('days') }}</b-input-group-text>
              </template>
              <b-form-input id="inv-payment_term" v-model="invoice.payment_term" :placeholder="(currentCompany.default_payment_term).toString()" />
            </b-input-group>
          </div>
          <!-- payment type (paid upfront) -->
          <div v-else class="step-1--options__option">
            <div class="invoice-section--label">{{ $gettext('Payment type') }}</div>
            <b-form-select v-model="invoice.invoice_payment.payment_type" :options="paymentTypeOptions" />
          </div>

          <div class="step-1--options__option">
            <b-form-checkbox
              id="checkbox-paidupfront"
              v-model="invoice.paid_up_front"
              name="checkbox-paidupfront"
            >
              <span>{{ $gettext('Already paid') }}</span>
            </b-form-checkbox>
          </div>

          <div class="step-1--options__option">
            <div class="invoice-section--label">{{ $gettext('Currency') }}</div>
            <CurrencyPicker @change="selectCurrency" />
          </div>
          <div class="step-1--options__option">
            <div class="invoice-section--label">{{ $gettext('Language') }}</div>
            <b-form-group label-class="gk-label-margin gk-modal-label">
              <b-form-select :options="languageOptions" v-model="invoice.language" :required="true" :placeholder="$gettext('Dutch')"></b-form-select>
            </b-form-group>
          </div>
        </div>
      </div><!-- end step-1--options-wrap -->
    </template>
    <template v-slot:actions>
      <GekkoButton
        @click="close()"
        :text="$gettext('Accept')"
      />
    </template>
  </ModalBase>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ModalBase from "@/components/base_components/ModalBase"
import TitleBar from "@/components/TitleBar"
import GekkoButton from "@/components/GekkoButton"

import CurrencyPicker from "@/components/CurrencyPicker"

export default {
  name: 'InvoiceDetailsModal',

  components: { 
    ModalBase,
    TitleBar,
    GekkoButton,
    CurrencyPicker
  },
  props: {
    invoice: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      paymentTypeOptions: [
        { value: 'cash', text: this.$gettext('Cash or private account') },
        { value: 'bank', text: this.$gettext('Bank transaction') }
      ],
    }
  },
  computed: {
    ...mapGetters({ 
      currentCompany: "main/getCurrentCompany",
      languageOptions: "main/getInvoiceLanguageOptions",
      storeInvoice: "invoices/getInvoice"
    }),
  },
  created () {
  },
  mounted () {
    document.body.classList.add('modal-on')
  },
  methods: {
    ...mapActions({

    }),
    close () {
      this.$emit('close')
      document.body.classList.remove('modal-on')
    },
    selectCurrency (currency) {
      this.invoice.currency = currency
    }
  }
}
</script>

<style lang="scss">
.gk-modal-invoice-details {
  .gk-modal {
    max-width: 530px !important;
    .step-1--options__option:not(:last-child) {
      padding-bottom: 1rem;
    }
    .invoice-section--label {
      font-size: 1rem;
    }

    .action-buttons-wrapper {
      display: flex;
      gap: 0.75rem;
      justify-content: flex-end;
    }
  }
}
</style>